import React from "react";

import Passers from "../Financials/components/Passers";
import { ContainerBg } from "../../useGeneralStyles";

const PassersPage = (): React.ReactElement => {
  return (
    <ContainerBg>
      <Passers />
    </ContainerBg>
  );
};

export default PassersPage;
